import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative overflow-hidden" data-id="element-38">
      {/* Flash Offer Banner */}
      <div className="w-full bg-red-600 text-white text-center py-2.5 px-4 font-bold text-sm sm:text-base tracking-wide" data-id="element-39">
        ⚡️ OFERTA RELÁMPAGO: €27 SOLO POR HOY
      </div>

      <div className="pt-8 pb-16 px-4 sm:px-6 lg:px-8 bg-beige-50 text-center" data-id="element-40">
        <div className="max-w-4xl mx-auto" data-id="element-41">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-42">
            <div className="mb-6" data-id="element-43">
              <img src="https://cdn.magicpatterns.com/uploads/js71Ma3S6J3LJSHVDa9JMa/IMG_1270.jpg" alt="Paty Valero - Mentora de Autoestima" className="w-64 sm:w-72 mx-auto rounded-xl shadow-lg" data-id="element-44" />
            </div>

            <h1 className="sm:text-5xl md:text-6xl font-bold text-dark mb-6 text-[38px]" data-id="element-45">
              Rompe Tu{' '}
              <span className="underline decoration-gold-400 decoration-3" data-id="element-46">
                Bloqueo en el Amor
              </span>{' '}
              con el <br className="hidden sm:block" data-id="element-47" />
              <span className="highlight-yellow" data-id="element-48">KIT Rompe-Patrones</span> en 3
              Días <br className="hidden sm:block" data-id="element-49" />
              para Volver a Sentirte{' '}
              <span className="font-extrabold" data-id="element-50">Elegida</span>
            </h1>
            <p className="text-lg sm:text-xl text-gray-700 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-51">
              <span className="font-bold text-dark" data-id="element-52">+400 mujeres</span> desde{' '}
              <span className="font-semibold" data-id="element-53">España</span> a{' '}
              <span className="font-semibold" data-id="element-54">Argentina</span> han roto el ciclo
              de atraer hombres sin compromiso y comenzaron a manifestar{' '}
              <span className="underline decoration-gold-400 decoration-2" data-id="element-55">
                relaciones sanas
              </span>{' '}
              en <span className="font-bold text-dark" data-id="element-56">tiempo récord</span> con
              este{' '}
              <span className="highlight-yellow font-bold" data-id="element-57">
                KIT Manifestador
              </span>
              .
            </p>

            <div className="relative max-w-3xl mx-auto mb-12 rounded-2xl overflow-hidden shadow-2xl aspect-video bg-black" data-id="element-58">
              <video src="https://cdn.magicpatterns.com/uploads/dunAFdLy7o8NBTC1o4fadV/WhatsApp Video 2026-04-29 at 5.30.39 p. m..mp4" controls playsInline className="w-full h-full" data-id="element-59" />
            </div>

            <a href="#pricing" className="inline-block bg-gold-500 hover:bg-gold-600 text-white font-bold text-lg py-4 px-10 rounded-full shadow-lg transform transition hover:-translate-y-1 hover:shadow-xl" data-id="element-60">
              QUIERO ACCESO INMEDIATO
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}